import React from 'react';
import {classes, st} from './SkeletonLineWrapper.st.css';
import {SkeletonLine} from '@wix/wix-ui-tpa/cssVars';

type SkeletonColorOverrideVariant = 'itemPrice' | 'footer';

interface SkeletonLineProps {
  size?: string;
  dataHook?: string;
  className?: string;
  colorOverrideVariant?: SkeletonColorOverrideVariant;
}

export const SkeletonLineWrapper = ({size, dataHook, className, colorOverrideVariant}: SkeletonLineProps) => {
  return (
    <SkeletonLine
      data-hook={dataHook}
      className={st(
        classes.root,
        colorOverrideVariant ? classes[colorOverrideVariant] : /* istanbul ignore next */ undefined,
        className ?? classes[size]
      )}
    />
  );
};
